import axios from "axios";
import TokenService from "./token.service";
import config from "../config.json";

const axiosInstance = axios.create({
	baseURL: config.ApiUrl,
});

axiosInstance.interceptors.request.use((config) => {
	const token = TokenService.getToken();
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (
			error.response.status === 401 &&
			error?.response?.data === "Invalid token"
		) {
			TokenService.removeToken();
			window.location = "/";
		} else {
			console.log("App Error:", error?.response);
		}
		throw error;
	}
);

export default axiosInstance;
